
export const KB_HELP_URL = 'https://help.hiverhq.com/knowledge-base/';
export const KB_SETUP_URL = 'https://help.hiverhq.com/knowledge-base/setting-up-your-knowledge-base';
export const VISIT_KB = 'Open Knowledge Base';
export const VISIT_DASHBOARD_AP = 'Edit Knowledge Base';
export const DELETE_KB = 'Delete Knowledge Base';
export const DELETE_CONFIRMATION = 'Delete {{kb}}';
export const DELETE_SUBMIT_TEXT = 'Delete this Knowledge Base for all users';
export const DELETE_MODAL_CONTENT = (<div>{'Permanently delete the Knowledge Base, including all articles and configurations, for all team members.'}</div>);
export const FOOTER_TEXT = 'Note: The Knowledge Base domain and article URLs will no longer be accessible.';
export const DELETE_KB_HEADER = 'Delete Knowledge Base';
export const KB_DELETED_SUCCESS = 'Knowledge Base deleted successfully';
export const KB_DELETED_FAILURE = 'Some error occured. Please contact support@hiverhq.com';
export const MULTI_KB_REQUEST_SUCCESS = 'Your request was submitted successfully.';
export const MULTI_KB_REQUEST_FAILURE = 'Some error occured. Please contact support@hiverhq.com'

export const GAINSIGHT_EVENTS = {
    KB_DELETED: 'kb_deleted',
    KB_LEARN_MORE_CLICK: 'kb_learn_more_clicked',
    MULTI_KB_START: 'multi_kb_request_start',
    MULTI_KB_SUBMITTED: 'multi_kb_request_submitted'
};

export const DELETE_KB_FEATURE_FLAG = 'ftr-delete-kb';
export const KB_INTERNAL_TAG_FEATURE_FLAG = 'ftr-kb-tag';
export const KB_FEEDBACK_FORM = 'ftr-kb-feedback-form';
export const INTERNAL_KB_TYPE = 'internal';
export const EXTERNAL_KB_TYPE = 'external';
export const KB_SETUP_QUESTION = 'Want to set-up an {{kbType}} Knowledge Base?';
export const LEARN_MORE = 'Learn more';
export const KB_TEXT = 'Knowledge Base';
export const KB_DELETE_DESCRIPTION = `Delete your current ${KB_TEXT} to create a new {{kbtype}} ${KB_TEXT}. `;
export const MULTI_KB_SETUP = 'Need multiple Knowledge Bases?';
export const MULTI_KB_DESCRIPTION = `This feature isn’t available yet, but we’re evaluating supporting multiple Knowledge Bases. Submit a request to express your interest.`;
export const SUBMIT_REQUEST = 'Submit request';
export const PENDING = 'pending';
export const CLOSED = 'CLOSED';
export const FORM_RESPONSE_QUERY_KEY = ['KBFormData'];
export const SUCCESS = 'success';

export const MULTI_KB_DATA = {
    "title": "Tell us what you need",
    "field_type": [
        {
            "type": "mcq_group",
            "options": [
                {
                    "label": "Need both internal and external Knowledge Bases",
                    "value": "option1",
                    "default": false
                },
                {
                    "label": "Need multiple external Knowledge Bases",
                    "value": "option2",
                    "default": false
                },
                {
                    "label": "Need multiple internal Knowledge Bases",
                    "value": "option3",
                    "default": false
                },
                {
                    "label": "Other(s)",
                    "value": "option4",
                    "default": false
                }
            ],
            "is_required": true
        },
        {
            "type": "text_box",
            "placeholder": "Tell us more about your requirements (optional)",
            "is_required": false
        },
        {
            "type": "product_connect",
            "label": "Register me for early access",
            "default": false
        }
    ],
    "next_popup": null,
    "submit_text": "Submit feedback"
}